export default {"src":"/_next/static/media/google.4ca61e71.svg","height":36,"width":27,"blurWidth":0,"blurHeight":0};